(() => {
  document.querySelectorAll('[data-multi-material-rfq]').forEach((form) => {
    if (form.dataset.multiMaterialBound === 'true') return;
    form.dataset.multiMaterialBound = 'true';

    const config = form.querySelector('.mmrfq__config');
    // Display labels never become option values, field IDs or legacy email tokens.
    const translations = new Map([...form.querySelectorAll('[data-rfq-translation]')].map((node) => [node.dataset.source, node.dataset.text]));
    const t = (source) => translations.get(source) || source;
    // Translate only exact default display strings. Native/Owner translations pass through.
    // Never walk configuration, option values, customer input or the English mail summary.
    const displayRoot = form.closest('.vantro-rfq-professional__layout') || form;
    const displayWalker = document.createTreeWalker(displayRoot, NodeFilter.SHOW_TEXT);
    let displayNode;
    while ((displayNode = displayWalker.nextNode())) {
      if (displayNode.parentElement.closest('.mmrfq__config, [data-rfq-translations], textarea, input, select, script, style, template')) continue;
      const source = displayNode.textContent.trim();
      if (source && t(source) !== source) displayNode.textContent = displayNode.textContent.replace(source, t(source));
    }
    form.querySelectorAll('[placeholder]').forEach((control) => {
      control.placeholder = t(control.placeholder);
    });
    const QUANTITY = Object.freeze({ undecided: 'Not decided', provided: 'Provided' });
    const review = form.querySelector('[data-rfq-localized-summary]');
    const reviewLabel = form.querySelector('[data-rfq-localized-label]');
    form.querySelectorAll('[data-rfq-delivery] option').forEach((option) => { const value = option.value; option.textContent = t(option.textContent); option.value = value; });
    const categories = [...form.querySelectorAll('[data-rfq-category]')].map((node) => ({ ...node.dataset }));
    const fields = [...form.querySelectorAll('[data-rfq-field]')].map((node) => ({ ...node.dataset }));
    const materialsNode = form.querySelector('[data-rfq-materials]');
    const summary = form.querySelector('[data-rfq-summary]');
    const success = form.querySelector('[data-rfq-success]');
    const submitButton = form.querySelector('button[type="submit"]');
    let submitting = false;
    const resetSubmission = () => {
      submitting = false;
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-disabled');
      form.removeAttribute('aria-busy');
      if (!success) submitButton.textContent = t(submitButton.dataset.defaultLabel || 'Send RFQ');
    };
    const unitLines = config ? config.dataset.unitOptions || '' : '';
    let materialSequence = 0;
    let removedMaterial = null;
    let currentStep = 1;

    const parseOptions = (value) => (value || '').split(/\r?\n/).map((item) => item.trim()).filter(Boolean);
    const makeId = (key) => `Rfq-${key}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    const purlinShape = (material) => ({ 'c-purlins': 'C', 'z-purlins': 'Z' })[material.querySelector('[data-material-category]').value] || '';

    const createInput = (definition, materialId) => {
      const wrapper = document.createElement('label');
      wrapper.className = definition.inputType === 'textarea' ? 'mmrfq__field--wide' : '';
      const controlId = makeId(`${materialId}-${definition.key}`);
      wrapper.setAttribute('for', controlId);
      wrapper.append(document.createTextNode(t(definition.label || definition.key)));
      let control;
      if (definition.inputType === 'select') {
        control = document.createElement('select');
        const blank = document.createElement('option');
        blank.value = '';
        blank.textContent = t('Select');
        control.append(blank);
        parseOptions(definition.options).forEach((optionText) => {
          const option = document.createElement('option');
          option.value = optionText;
          option.textContent = t(optionText);
          control.append(option);
        });
      } else if (definition.inputType === 'textarea') {
        control = document.createElement('textarea');
        control.rows = 3;
      } else {
        control = document.createElement('input');
        control.type = definition.inputType === 'number' ? 'number' : 'text';
        if (control.type === 'number') { control.min = '0.000001'; control.step = 'any'; }
      }
      control.id = controlId;
      control.dataset.specKey = definition.key;
      control.dataset.specLabel = definition.label || definition.key;
      if (definition.unit === 'mm' && control.type === 'number') {
        control.dataset.specUnit = 'mm';
        control.min = '0';
        control.inputMode = 'decimal';
        control.addEventListener('input', () => {
          control.setCustomValidity(control.value !== '' && Number(control.value) <= 0 ? t('Enter a positive dimension or leave blank.') : '');
        });
      }
      if (definition.required === 'true') { control.required = true; control.setAttribute('aria-required', 'true'); }
      wrapper.append(control);
      if (definition.help) {
        const help = document.createElement('span');
        help.className = 'mmrfq__help';
        help.textContent = t(definition.help);
        wrapper.append(help);
      }
      return wrapper;
    };

    const categorySelect = (materialId) => {
      const label = document.createElement('label');
      const id = makeId(`${materialId}-category`);
      label.setAttribute('for', id);
      label.append(document.createTextNode(t('Material category')));
      const select = document.createElement('select');
      select.id = id;
      select.dataset.materialCategory = '';
      select.required = true;
      select.setAttribute('aria-required', 'true');
      const blank = document.createElement('option');
      blank.value = '';
      blank.textContent = t('Select a category');
      select.append(blank);
      categories.forEach((category) => {
        const option = document.createElement('option');
        option.value = category.value;
        option.textContent = t(category.label);
        option.dataset.mapping = category.mapping;
        select.append(option);
      });
      label.append(select);
      return label;
    };

    const buildCommonFields = () => {
      const fragment = document.createDocumentFragment();
      const statusLabel = document.createElement('label');
      statusLabel.append(document.createTextNode(t('Quantity status')));
      const status = document.createElement('select');
      status.dataset.quantityStatus = '';
      [[QUANTITY.undecided, config.dataset.quantityUndecided], [QUANTITY.provided, config.dataset.quantityEnter]].forEach(([value, text]) => {
        const option = document.createElement('option'); option.value = value; option.textContent = t(text); status.append(option);
      });
      statusLabel.append(status);
      fragment.append(statusLabel);

      const quantityLabel = document.createElement('label');
      quantityLabel.append(document.createTextNode(t('Quantity')));
      const quantity = document.createElement('input');
      quantity.type = 'number'; quantity.min = '0.000001'; quantity.step = 'any'; quantity.dataset.quantity = ''; quantity.disabled = true;
      quantityLabel.hidden = true; quantityLabel.append(quantity); fragment.append(quantityLabel);

      const unitLabel = document.createElement('label');
      unitLabel.append(document.createTextNode(t('Unit')));
      const unit = document.createElement('select');
      unit.dataset.unit = ''; unit.disabled = true; unit.append(new Option(t('Select a unit'), ''));
      parseOptions(unitLines).forEach((value) => { const option = document.createElement('option'); option.value = value; option.textContent = t(value); unit.append(option); });
      unitLabel.hidden = true; unitLabel.append(unit); fragment.append(unitLabel);

      const additional = document.createElement('details');
      additional.className = 'mmrfq__additional mmrfq__field--wide';
      const heading = document.createElement('summary'); heading.textContent = t(config.dataset.additionalLabel);
      const optionalSpecs = document.createElement('div'); optionalSpecs.dataset.materialOptionalSpecs = '';
      additional.append(heading, optionalSpecs);

      const notesLabel = document.createElement('label');
      notesLabel.className = 'mmrfq__field--wide'; notesLabel.append(document.createTextNode(t('Material notes (optional)')));
      const notes = document.createElement('textarea'); notes.rows = 3; notes.dataset.materialNotes = '';
      notesLabel.append(notes); additional.append(notesLabel); fragment.append(additional);
      return fragment;
    };

    const updateMaterialLabels = () => [...materialsNode.children].forEach((material, index) => { material.querySelector('[data-material-title]').textContent = `${t('Material')} ${index + 1}`; });
    const renderSpecs = (material, mapping) => {
      const specNode = material.querySelector('[data-material-specs]');
      specNode.replaceChildren();
      const optionalSpecs = material.querySelector('[data-material-optional-specs]');
      optionalSpecs.replaceChildren();
      const shape = purlinShape(material);
      const guide = form.querySelector('template[data-rfq-purlin-guide]');
      if (mapping === 'purlin' && guide) {
        const content = guide.content.cloneNode(true);
        content.querySelectorAll('strong, p, figcaption').forEach((node) => { node.textContent = t(node.textContent); });
        if (shape) content.querySelectorAll('[data-purlin-shape]').forEach((figure) => { if (figure.dataset.purlinShape !== shape) figure.remove(); });
        specNode.append(content);
      }
      fields.filter((field) => field.mapping === mapping).forEach((field) => {
        if (shape && field.key === 'section') return;
        const target = mapping === 'purlin' && field.key === 'hole_requirements' ? optionalSpecs : specNode;
        target.append(createInput(field, material.dataset.materialId));
      });
    };

    const addMaterial = (sourceData) => {
      materialSequence += 1;
      const materialId = `material-${materialSequence}`;
      const article = document.createElement('article');
      article.className = 'mmrfq__material'; article.dataset.materialId = materialId;
      article.innerHTML = '<div class="mmrfq__material-head"><strong data-material-title></strong><button type="button" data-rfq-collapse aria-expanded="true">Collapse</button><button type="button" data-rfq-duplicate>Duplicate</button><button type="button" data-rfq-remove>Remove</button></div><div class="mmrfq__material-body"><div class="mmrfq__field-grid" data-material-grid></div></div>';
      article.querySelectorAll('button').forEach((button) => { button.textContent = t(button.textContent); });
      const grid = article.querySelector('[data-material-grid]');
      grid.append(categorySelect(materialId));
      const specs = document.createElement('div'); specs.className = 'mmrfq__specs'; specs.dataset.materialSpecs = ''; grid.append(specs);
      grid.append(buildCommonFields()); materialsNode.append(article); updateMaterialLabels();
      if (sourceData) restoreMaterial(article, sourceData);
      return article;
    };

    const materialData = (material) => {
      const categoryNode = material.querySelector('[data-material-category]');
      const selected = categoryNode.options[categoryNode.selectedIndex];
      const specs = [...material.querySelectorAll('[data-spec-key]')].map((control) => ({ key: control.dataset.specKey, label: control.dataset.specLabel, value: control.value, displayValue: control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent || '' : control.value, unit: control.dataset.specUnit || '' }));
      const shape = purlinShape(material);
      if (shape) {
        const section = fields.find((field) => field.mapping === 'purlin' && field.key === 'section');
        specs.unshift({ key: 'section', label: section ? section.label : 'Section', value: `${shape} section`, displayValue: t(`${shape} section`), unit: '' });
      }
      return {
        category: categoryNode.value,
        categoryLabel: (categories.find((category) => category.value === categoryNode.value) || {}).label || '',
        mapping: selected ? selected.dataset.mapping || 'generic' : 'generic',
        specs,
        quantityStatus: material.querySelector('[data-quantity-status]').value,
        quantity: material.querySelector('[data-quantity]').value,
        unit: material.querySelector('[data-unit]').value,
        notes: material.querySelector('[data-material-notes]').value
      };
    };

    const toggleQuantity = (material) => {
      const provided = material.querySelector('[data-quantity-status]').value === QUANTITY.provided;
      const quantity = material.querySelector('[data-quantity]'); const unit = material.querySelector('[data-unit]');
      quantity.disabled = !provided; unit.disabled = !provided; quantity.required = provided; unit.required = provided;
      quantity.parentElement.hidden = !provided; unit.parentElement.hidden = !provided;
      if (!provided) { quantity.value = ''; unit.value = ''; }
    };

    const restoreMaterial = (material, data) => {
      const category = material.querySelector('[data-material-category]'); category.value = data.category || '';
      renderSpecs(material, data.mapping || 'generic');
      (data.specs || []).forEach((saved) => { const control = [...material.querySelectorAll('[data-spec-key]')].find((item) => item.dataset.specKey === saved.key || item.dataset.specLabel === saved.label); if (control) control.value = saved.value || ''; });
      const status = material.querySelector('[data-quantity-status]'); status.value = data.quantityStatus || QUANTITY.undecided; toggleQuantity(material);
      if (status.value === QUANTITY.provided) { material.querySelector('[data-quantity]').value = data.quantity || ''; material.querySelector('[data-unit]').value = data.unit || ''; }
      material.querySelector('[data-material-notes]').value = data.notes || '';
    };

    const routeValue = () => form.querySelector('input[name="rfq-route"]:checked').value;
    const setRoute = () => {
      const list = routeValue() === 'list'; form.querySelector('[data-rfq-material-route]').hidden = list; form.querySelector('[data-rfq-list-route]').hidden = !list;
      [...materialsNode.querySelectorAll('select, input, textarea')].forEach((control) => { control.disabled = list; });
      if (!list) [...materialsNode.children].forEach((material) => { [...material.querySelectorAll('select, input, textarea')].forEach((control) => { control.disabled = false; }); toggleQuantity(material); });
    };

    const showStep = (step) => {
      currentStep = Number(step);
      form.querySelectorAll('[data-rfq-step]').forEach((panel) => panel.classList.toggle('is-current', Number(panel.dataset.rfqStep) === currentStep));
      form.querySelectorAll('[data-rfq-go]').forEach((button) => {
        const number = Number(button.dataset.rfqGo); button.classList.toggle('is-current', number === currentStep); button.classList.toggle('is-complete', number < currentStep);
        if (number === currentStep) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
      });
      if (currentStep === 3) refreshSummary();
      const heading = form.querySelector(`[data-rfq-step="${currentStep}"] h3`); if (heading) heading.focus({ preventScroll: true });
    };

    const validateStep = (step) => {
      if (step === 1 && routeValue() === 'list') {
        const project = form.querySelector('[data-rfq-project-summary]');
        if (!project.value.trim()) { project.setCustomValidity(t('Please add a short project or material-list summary.')); project.reportValidity(); project.setCustomValidity(''); return false; }
        return true;
      }
      const panel = form.querySelector(`[data-rfq-step="${step}"]`);
      panel.querySelectorAll('[data-spec-unit="mm"]').forEach((control) => {
        control.setCustomValidity(control.value !== '' && Number(control.value) <= 0 ? t('Enter a positive dimension or leave blank.') : '');
      });
      const invalid = [...panel.querySelectorAll('input, select, textarea')].filter((control) => !control.disabled).find((control) => !control.checkValidity());
      if (invalid) {
        const details = invalid.closest('details'); if (details) details.open = true;
        const material = invalid.closest('[data-material-id]');
        if (material && material.classList.contains('is-collapsed')) material.querySelector('[data-rfq-collapse]').click();
        invalid.reportValidity(); return false;
      }
      return true;
    };

    const line = (label, value) => value && String(value).trim() ? `${label}: ${String(value).trim()}` : null;
    const serialize = (localized = false) => {
      const label = localized ? t : (value) => value;
      const output = [label('VANTRO MULTI-MATERIAL RFQ'), ''];
      if (routeValue() === 'list') output.push(`${label('INQUIRY ROUTE')}: ${label('Drawings / material list')}`, line(label('Project summary'), form.querySelector('[data-rfq-project-summary]').value) || `${label('Project summary')}: ${label('Not provided')}`);
      else {
        output.push(`${label('INQUIRY ROUTE')}: ${label('Itemized materials')}`, '');
        [...materialsNode.children].forEach((material, index) => {
          const data = materialData(material); output.push(`${localized ? label('Material') : 'MATERIAL'} ${index + 1}`, line(label('Category'), localized ? t(data.categoryLabel) : data.categoryLabel) || `${label('Category')}: ${label('Not selected')}`);
          data.specs.forEach((spec) => { if (spec.value.trim()) output.push(`${label(spec.label)}: ${(localized ? spec.displayValue : spec.value).trim()}${spec.unit ? ` ${spec.unit}` : ''}`); });
          output.push(data.quantityStatus === QUANTITY.provided ? `${label('Quantity')}: ${data.quantity} ${localized ? t(data.unit) : data.unit}` : `${label('Quantity')}: ${label('Not decided')}`);
          if (data.notes.trim()) output.push(`${label('Material notes')}: ${data.notes.trim()}`); output.push('');
        });
      }
      output.push(label('PROJECT & DELIVERY'));
      form.querySelectorAll('[data-rfq-delivery]').forEach((control) => {
        const value = localized && control.tagName === 'SELECT' && control.value ? control.selectedOptions[0].textContent : control.value;
        output.push(line(label(control.dataset.rfqDelivery), value) || `${label(control.dataset.rfqDelivery)}: ${label('Not provided')}`);
      });
      const additional = form.querySelector('[data-rfq-additional]').value.trim(); if (additional) output.push('', label('ADDITIONAL REQUIREMENTS'), additional);
      return output.join('\n');
    };
    // Only the original editable English contact[body] is submitted. Translated
    // review has no name and is never parsed as a business identifier or payload.
    const refreshReview = () => {
      if (!review) return;
      const translated = t('VANTRO MULTI-MATERIAL RFQ') !== 'VANTRO MULTI-MATERIAL RFQ';
      review.hidden = !translated; reviewLabel.hidden = !translated;
      review.textContent = serialize(true);
    };
    const refreshSummary = () => { summary.value = serialize(); refreshReview(); };

    const restoreFromPayload = (payload) => {
      if (!payload.startsWith('VANTRO MULTI-MATERIAL RFQ')) return false;
      const lines = payload.split(/\r?\n/); const listRoute = lines.includes('INQUIRY ROUTE: Drawings / material list');
      if (listRoute) {
        form.querySelector('input[name="rfq-route"][value="list"]').checked = true;
        const projectLine = lines.find((item) => item.startsWith('Project summary: '));
        form.querySelector('[data-rfq-project-summary]').value = projectLine ? projectLine.replace('Project summary: ', '') : '';
      } else {
        const groups = payload.split(/\n(?=MATERIAL \d+\n)/).slice(1);
        materialsNode.replaceChildren();
        groups.forEach((group) => {
          const groupLines = group.split(/\r?\n/); const categoryLabel = (groupLines.find((item) => item.startsWith('Category: ')) || '').replace('Category: ', '');
          const category = categories.find((item) => item.label === categoryLabel); if (!category) return;
          const definitionList = fields.filter((item) => item.mapping === category.mapping);
          const saved = { category: category.value, categoryLabel, mapping: category.mapping, specs: [], quantityStatus: 'Not decided', quantity: '', unit: '', notes: '' };
          definitionList.forEach((definition) => { const valueLine = groupLines.find((item) => item.startsWith(`${definition.label}: `)); if (valueLine) { let value = valueLine.slice(definition.label.length + 2); if (definition.unit === 'mm') value = value.replace(/ mm$/, ''); saved.specs.push({ key: definition.key, label: definition.label, value }); } });
          const quantityLine = groupLines.find((item) => item.startsWith('Quantity: '));
          if (quantityLine && quantityLine !== 'Quantity: Not decided') { const raw = quantityLine.replace('Quantity: ', ''); const firstSpace = raw.indexOf(' '); saved.quantityStatus = 'Provided'; saved.quantity = firstSpace > -1 ? raw.slice(0, firstSpace) : raw; saved.unit = firstSpace > -1 ? raw.slice(firstSpace + 1) : ''; }
          const notesLine = groupLines.find((item) => item.startsWith('Material notes: ')); if (notesLine) saved.notes = notesLine.replace('Material notes: ', ''); addMaterial(saved);
        });
        if (!materialsNode.children.length) addMaterial();
      }
      form.querySelectorAll('[data-rfq-delivery]').forEach((control) => {
        const prefix = `${control.dataset.rfqDelivery}: `;
        const saved = lines.find((item) => item.startsWith(prefix));
        if (saved) { const value = saved.slice(prefix.length); control.value = value === 'Not provided' ? '' : value; }
      });
      const additionalStart = lines.indexOf('ADDITIONAL REQUIREMENTS');
      if (additionalStart >= 0) form.querySelector('[data-rfq-additional]').value = lines.slice(additionalStart + 1).join('\n');
      setRoute(); return true;
    };

    materialsNode.addEventListener('change', (event) => {
      const material = event.target.closest('[data-material-id]'); if (!material) return;
      if (event.target.matches('[data-material-category]')) { const selected = event.target.options[event.target.selectedIndex]; renderSpecs(material, selected ? selected.dataset.mapping || 'generic' : 'generic'); }
      if (event.target.matches('[data-quantity-status]')) toggleQuantity(material);
    });

    form.addEventListener('click', (event) => {
      const button = event.target.closest('button'); if (!button) return;
      if (button.matches('[data-rfq-add]')) addMaterial();
      if (button.matches('[data-rfq-duplicate]')) addMaterial(materialData(button.closest('[data-material-id]')));
      if (button.matches('[data-rfq-collapse]')) { const material = button.closest('[data-material-id]'); material.classList.toggle('is-collapsed'); const expanded = !material.classList.contains('is-collapsed'); button.setAttribute('aria-expanded', String(expanded)); button.textContent = t(expanded ? 'Collapse' : 'Expand'); }
      if (button.matches('[data-rfq-remove]')) { const material = button.closest('[data-material-id]'); if (materialsNode.children.length === 1) return; removedMaterial = { data: materialData(material), index: [...materialsNode.children].indexOf(material) }; material.remove(); updateMaterialLabels(); form.querySelector('[data-rfq-undo]').hidden = false; }
      if (button.matches('[data-rfq-undo]') && removedMaterial) { const restored = addMaterial(removedMaterial.data); const reference = materialsNode.children[removedMaterial.index]; if (reference && reference !== restored) materialsNode.insertBefore(restored, reference); removedMaterial = null; button.hidden = true; updateMaterialLabels(); }
      if (button.matches('[data-rfq-next]')) { const step = Number(button.dataset.rfqNext) - 1; if (validateStep(step)) showStep(button.dataset.rfqNext); }
      if (button.matches('[data-rfq-prev]')) showStep(button.dataset.rfqPrev);
      if (button.matches('[data-rfq-go]')) { const target = Number(button.dataset.rfqGo); if (target <= currentStep || validateStep(currentStep)) showStep(target); }
      if (button.matches('[data-rfq-refresh]')) refreshSummary();
    });
    form.querySelectorAll('input[name="rfq-route"]').forEach((radio) => radio.addEventListener('change', setRoute));
    form.addEventListener('submit', (event) => {
      // The disabled button prevents repeat clicks. Never cancel a native captcha continuation.
      if (submitting) return;
      const stepOneValid = validateStep(1); const stepTwoValid = validateStep(2);
      if (!stepOneValid || !stepTwoValid) { event.preventDefault(); resetSubmission(); showStep(stepOneValid ? 2 : 1); return; }
      if (!summary.value.trim()) refreshSummary();
      if (!form.checkValidity()) { event.preventDefault(); resetSubmission(); form.reportValidity(); return; }
      submitting = true;
      form.setAttribute('aria-busy', 'true');
      submitButton.disabled = true; submitButton.setAttribute('aria-disabled', 'true'); submitButton.textContent = t(submitButton.dataset.submitLabel || 'Sending…');
    });
    form.addEventListener('invalid', (event) => {
      resetSubmission();
      if (document.documentElement.lang.split('-')[0] !== 'tr') return;
      const control = event.target;
      const message = control.validity.valueMissing ? 'Please complete this required field.'
        : control.validity.typeMismatch && control.type === 'email' ? 'Please enter a valid email address.'
          : control.validity.badInput || control.validity.rangeUnderflow ? 'Please enter a valid positive number.' : '';
      if (message) { control.setCustomValidity(t(message)); control.dataset.rfqLocalizedInvalid = 'true'; }
    }, true);
    const clearLocalizedValidity = (event) => {
      if (event.target.dataset.rfqLocalizedInvalid) {
        event.target.setCustomValidity('');
        delete event.target.dataset.rfqLocalizedInvalid;
      }
    };
    form.addEventListener('input', clearLocalizedValidity, true);
    form.addEventListener('change', clearLocalizedValidity, true);

    if (!restoreFromPayload(summary.value.trim())) addMaterial();
    setRoute(); form.classList.add('mmrfq-ready');
    if (success) {
      submitButton.disabled = false; submitButton.removeAttribute('aria-disabled'); submitButton.textContent = t(submitButton.dataset.successLabel || 'Request Sent');
      requestAnimationFrame(() => { success.focus({ preventScroll: true }); success.scrollIntoView({ behavior: 'auto', block: 'start' }); });
    }
    window.addEventListener('pageshow', resetSubmission);
  });
})();
